import { SCROLL_OFFSET } from 'src/utils/constants/utilConstants';

import { isConsumptionPageCheck } from './checkConsumptionPage';

let observer: IntersectionObserver | undefined;
let removeObserver = false;

export default function fetchNextPage(
  fetchFunction: () => void,
  removeObserverInstance: boolean,
  className: string,
  offset = SCROLL_OFFSET
): void | null {
  removeObserver = removeObserverInstance;
  const element = document.querySelector(`.${className}`);
  if (element === null || !element.lastChild) return null;

  if (
    removeObserverInstance &&
    observer &&
    element.lastChild instanceof Element
  ) {
    observer.unobserve(element.lastChild);
    observer = undefined;
    return null;
  }

  if (removeObserverInstance) {
    return null;
  }

  const isConsumption = isConsumptionPageCheck(
    window.location.pathname as string
  );

  const options: IntersectionObserverInit = {
    root: null /* or`null` for page as root */,
    rootMargin: isConsumption ? '0px' : `${offset}px`,
    threshold: isConsumption ? [0.4, 1] : 0.4
  };

  const callback: IntersectionObserverCallback = (entities) => {
    const intersectionRatio = entities[0].intersectionRatio;
    if (intersectionRatio > 0.4) {
      if (!removeObserver && observer) {
        fetchFunction();
      }
      if (observer && element.lastChild instanceof Element) {
        observer.unobserve(element.lastChild);
      }
      observer = undefined;
    }
  };

  observerHandler(element, callback, options);

  return null;
}

const observerHandler = (
  element: Element,
  callback: IntersectionObserverCallback,
  options: IntersectionObserverInit
) => {
  if (window.IntersectionObserver) {
    observer = new IntersectionObserver(callback, options);
    if (element.lastChild instanceof Element) {
      observer.observe(element.lastChild);
    }
  } else {
    const timer = setInterval(() => {
      if (window.IntersectionObserver) {
        observer = new IntersectionObserver(callback, options);
        if (element.lastChild instanceof Element) {
          observer.observe(element.lastChild);
        }
        clearInterval(timer);
      }
    }, 500);
  }
};
